/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Processes_QuestionInputs */

const en_faq_processes_question = /** @type {(inputs: Faq_Processes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can you build with AI?`)
};

const lv_faq_processes_question = /** @type {(inputs: Faq_Processes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko varat izveidot ar mākslīgo intelektu?`)
};

/**
* | output |
* | --- |
* | "What can you build with AI?" |
*
* @param {Faq_Processes_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_processes_question = /** @type {((inputs?: Faq_Processes_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Processes_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_processes_question(inputs)
	return en_faq_processes_question(inputs)
});